// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { activeStateTrue } from "@tps/App/Widgets/SearchEngineOptimization/ActiveState";
import { SeoAppProps, SeoHandlerProps } from "@tps/App/Widgets/SearchEngineOptimization/Type";
import { WebSite, WithContext } from "@tps/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaWebsite = ({ state, fields, url }: SeoAppProps): WithContext<WebSite> => {
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: fields.organizationName || state.context.website.name,
        url,
        publisher: {
            "@type": "Organization",
            name: fields.organizationName || state.context.website.name,
            logo: {
                "@type": "ImageObject",
                url: fields.logoUrl,
                name: fields.organizationName || state.context.website.name,
            },
        },
        potentialAction: {
            "@type": "SearchAction",
            target: `${url}/search?query={search_term_string}`,
            query: "required name=search_term_string",
        },
    };
};

export default {
    isActivate: activeStateTrue,
    buildSchema: loadSchemaWebsite,
} as SeoHandlerProps;
